import BottomSheet from '../BottomSheet'
import PlayerInfo from '../PlayerInfo'
import Style from './style'
import StoreSection from './ui/StoreSection'

const StoreEventBottomSheet = ({
	isOpen,
	onClose,
	scanData = null,
	handleRefetch,
	isLoading,
}) => {
	const handleClose = () => {
		onClose()
	}
	const userInfo = scanData?.user_info || {}

	// Map pro_grade_flag to qualification text
	const getQualification = (proGradeFlag) => {
		switch (proGradeFlag) {
			case 1:
				return 'Amateur'
			case 2:
				return 'Pro'
			case 3:
				return 'Rookie pro'
			default:
				return 'Player'
		}
	}

	return (
		<BottomSheet
			isOpen={isOpen}
			onClose={handleClose}
			title='Player information'
			showCloseButton={true}
		>
			<Style.Content>
				{/* Player Information */}
				<PlayerInfo
					nickname={userInfo.nickname || '홀덤여신'}
					name={userInfo.name || '정미애'}
					phoneNumber={userInfo.contact || '010-3714-0305'}
					playerId={userInfo.idx || '176'}
					qualification={getQualification(userInfo.pro_grade_flag)}
					isVerified={true}
					avatarUrl={userInfo.profile_img || null}
				/>

				<StoreSection
					scanData={scanData}
					refetch={handleRefetch}
					user_idx={userInfo.idx}
					isLoading={isLoading}
				/>
			</Style.Content>
		</BottomSheet>
	)
}

export default StoreEventBottomSheet
